const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./components/${handle}`
    ).then((module) => {
      if (typeof module.default === 'function') {
        const instance = module.default(node, ctx);
        const unsubscribe = ctx.on('unmount', () => {
          instance.unmount();
          unsubscribe();
        });
      }
    });
  };
};

// UI COMPONENTS ==============================================================
import HeaderUtils from './components/ui/HeaderUtils';
import PredictiveSearch from './components/ui/PredictiveSearch';
import QuickSearch from './components/ui/QuickSearch';
// import DesktopSearchBar from './components/ui/DesktopSearchBar';

// NAV COMPONENTS ==============================================================
//import MobileNav from './components/nav/MobileNav';
import MainMenu from './components/nav/MainMenu';
import * as FooterNav from './components/nav/FooterNav';

export const AppComponents = {
  // Content Components ------------------------------------------------------------
  FeaturedCollection: asyncComponentFactory('content/FeaturedCollection'),
  HeroVideo: asyncComponentFactory('content/HeroVideo'),
  CollectionsList: asyncComponentFactory('content/CollectionsList'),
  RichText: asyncComponentFactory('content/RichText'),
  MediaContent: asyncComponentFactory('content/MediaContent'),

  MosaicGallery: asyncComponentFactory('content/MosaicGallery'),
  TopBrands: asyncComponentFactory('content/TopBrands'),
  StoreReviews: asyncComponentFactory('content/StoreReviews'),
  Banner: asyncComponentFactory('content/Banner'),
  PageGallery: asyncComponentFactory('content/PageGallery'),

  // Account Components ------------------------------------------------------------
  Login: asyncComponentFactory('account/Login'),
  Addresses: asyncComponentFactory('account/Addresses'),

  // Product Components ------------------------------------------------------------

  ProductForm: asyncComponentFactory('product/ProductForm'),
  AddToCartButton: asyncComponentFactory('product/AddToCart'),
  QuantityInput: asyncComponentFactory('product/QuantityInput'),
  ProductBuilder: asyncComponentFactory('product/ProductBuilder'),
  ProductGallery: asyncComponentFactory('product/ProductGallery'),
  ProductRecommendations: asyncComponentFactory('product/ProductRecommendations'),
  RecentlyViewed: asyncComponentFactory('product/RecentlyViewed'),

  // MEDIA Components ------------------------------------------------------------
  MediaPlayer: asyncComponentFactory('media/MediaPlayer'),

  // UI Components ------------------------------------------------------------
  PredictiveSearch,
  QuickSearch,
  HeaderUtils,
  // DesktopSearchBar,
  Drawer: asyncComponentFactory('ui/Drawer'),
  Dropdown: asyncComponentFactory('ui/Dropdown'),
  Accordion: asyncComponentFactory('ui/Accordion'),
  Slider: asyncComponentFactory('ui/Slider'),
  SwiperSlider: asyncComponentFactory('ui/SwiperSlider'),
  Modal: asyncComponentFactory('ui/Modal'),
  ReadMore: asyncComponentFactory('ui/ReadMore'),
  Tabs: asyncComponentFactory('ui/Tabs'),
  CustomSelect: asyncComponentFactory('ui/CustomSelect'),
  JumpTo: asyncComponentFactory('ui/JumpTo'),

  // NAV Components ------------------------------------------------------------
  LazyLoader: asyncComponentFactory('nav/LazyLoader'),
  VerticalNav: asyncComponentFactory('nav/VerticalNav'),
  //MobileNav,
  MainMenu,
  FooterNav,
};
